<template>
  <div>
    <b-button 
      v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" @click="openDeleteMonitoringZone" >
      <i class="fa fa-trash"></i>
    </b-button>


    <!-- Crea nuova Monitoring Zone Modal-->
    <b-modal
      ref="modal"
      size="lg"
      :id="'modal-delete-zone'+this._uid"
      :saveSubmit="saveSubmit"
      :title="$t('monitoring_zone.modal_title_delete')"
      :ok-title="$t('monitoring_zone.modal_title_delete')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-row>
      <b-col cols="12" class="p-5"> 
        <div><label class="typo-title">{{$t('monitoring_zone.label_zone_delete_title')}} <b>{{this.zone.zoneName}}</b> ?</label> </div>
        <div><i class="fa fa-exclamation-triangle" style="color:orange;"></i><label class="typo-title ml-2"> {{$t('monitoring_zone.label_zone_delete_subtitle')}}</label> </div>
      </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";


export default {
  name: "DeleteMonitoringZone",
  data() {
    return {
     zoneName: "",
     saveSubmit: "false",
    };
  },
props: {
    zone: {
      default: null
    }
  },
  computed: {
    ...mapState(['loading','error','commandsPending','commandResponse']),
  },
  mounted() {
        console.log("delete MonitoringZone mounted");
        
  },
  methods: {
    openDeleteMonitoringZone() {
      this.$bvModal.show('modal-delete-zone'+this._uid);
    }, 
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      this.deleteZone();
    },
    deleteZone() {     
      this.$store.dispatch("deleteMonitoringZone", {
            plantId: this.zone.plantId,
            zoneId: this.zone.zoneId,
      });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
      
    }
  },

  watch: {
        loading(val) {
            console.log("zone loading changed:" + val+", error=" + this.error)
        },
        commandResponse(val) {
          console.log("updated commandResponse:",val);
          if (val.command == 'deleteMonitoringZone' && val.pending == false && val.error.data == '') 
            {
              console.log("monitoring zone deleted", val);
              this.$store.dispatch('loadPlantMonitoringZones', this.zone.plantId);  
            } 
        }
    },
};
</script>
